import { allowsSite, type SiteFilter } from '../siteFilter'
import type { Site } from '../types'

const list = new Intl.ListFormat('en', { style: 'long', type: 'conjunction' })

// FilterStrip says over the wall what a filter is showing, since a short wall
// otherwise reads as a quiet one, and that the alerts rail follows it.
export function FilterStrip({ sites, filter, hidden, onClear }: { sites: Site[]; filter: SiteFilter; hidden?: string; onClear: () => void }) {
  const shown = sites
    .filter((s) => allowsSite(filter, s.id))
    .map((s) => {
      const chosen = filter.cameras[s.id]
      const name = s.name || s.id
      return chosen ? `${name} (${chosen.size} ${chosen.size === 1 ? 'camera' : 'cameras'})` : name
    })
  return (
    <div role="status" aria-label="Filter" className="flex flex-wrap items-center gap-x-3 gap-y-2 px-3.5 py-2.5 rounded-lg border border-orange-400/45 bg-orange-500/10 text-sm text-zinc-100">
      <svg aria-hidden="true" className="w-4 h-4 shrink-0 text-orange-300" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
        <path strokeLinecap="round" d="M4 6h16M7 12h10M10 18h4" />
      </svg>
      <span className="flex-1 min-w-0">
        {hidden && <strong className="font-semibold">{hidden} is hidden by this filter. </strong>}
        {shown.length ? `Showing ${list.format(shown)}.` : 'Showing no sites.'} Alerts are filtered the same way.
      </span>
      <button type="button" onClick={onClear} className="h-8 px-3 rounded-md border border-orange-400/45 text-sm font-semibold text-zinc-100 hover:bg-orange-500/15">
        Clear filter
      </button>
    </div>
  )
}
